<template>
  <div
    :class="['control-promotions', classLocator]"
    @mouseenter="toggleDropdown(true)"
    @mouseleave="toggleDropdown(false)"
  >
    <a
      class="control-promotions__link icon"
      href="/account/notifications"
      @click="onClicknotificationsLink"
    >
      <ui-badge
        :text="notificationsCount"
        color="#F34744"
        :loading="isLoading"
        max-width="50"
      />
      <f-sprite-icon :icon-link="$options.icons.IconNotifications" />
    </a>

    <ui-dropdown
      :visible="isDropdownShown && $isFeatureEnabled"
      overlay-height="40"
      class="control-promotions__dropdown"
    >
      <page-info
        v-if="!notifications?.length"
        class="control-promotions__empty"
        :subtitle="subtitle"
      />
      <notifications-promotions
        v-else
        :notifications="notifications"
        :class-locator="classLocator"
        @timer-is-ended="store.dispatch('promotions/fetchMessages')"
      />
    </ui-dropdown>
  </div>
</template>

<script lang="ts">
import {
  computed, inject, onMounted,
  ref,
} from 'vue';
import { useStore } from 'vuex';

import features from '@common/constants/features';

/* Icons */
import IconNotifications from '../../assets/icons/notifications.svg';

export default {
  name: 'control-promotions',

  icons: {
    IconNotifications,
  },
};
</script>

<script setup lang="ts">
import NotificationsPromotions from '@/components/app-kit/notifications-promotions/notifications-promotions.vue';
import PageInfo from '@/components/common/page-info.vue';
import { promotionsGtmEvents } from '@/gtm/promotions-gtm-events';

type Subscription = {
  code: string,
  active: boolean,
}

interface IProps {
  location: string,
}

const store = useStore();
const adaptive = inject('adaptive');
const props = defineProps<IProps>();

const $isFeatureEnabled = store.getters['features/$isFeatureEnabled'](features.NOTIFICATION_WIDGET);
const classLocator = computed(() => `control-promotions-${props.location}`);
const notifications = computed(() => store.getters['promotions/messages']);
const notificationsCount = computed<number>(() => store.getters['promotions/messagesCount']);
const isLoading = computed(() => store.getters['promotions/isLoading']);

onMounted(async () => {
  if (isLoading.value || notifications?.value?.length) return;
  await store.dispatch('promotions/fetchUnreadMessagesCount');
});

const isDropdownShown = ref<boolean>(false);
const isSubscriptionActivated = computed(() => store.getters['user/subscriptions'].some(((sub: Subscription) => sub.active)));

const link = '/account/subscribes';
const subtitle = computed<string>(() => {
  if (isSubscriptionActivated.value) return 'Список уведомлений пуст';

  return `<a href='${link}'>Подпишитесь</a> на рассылку об акциях, новинках и скидках.`;
});

const toggleDropdown = async (value: boolean) => {
  if (!adaptive.isDesktop) return;
  isDropdownShown.value = value;
};

const onClicknotificationsLink = () => {
  promotionsGtmEvents.onClickNotificationsBellLink();
};

</script>

<style lang="scss">
.control-promotions {
  position: relative;

  & .ui-dropdown {
    padding: 8px 0;
    top: 40px;
    width: 360px;
    max-height: 458px;
    left: -180px;
    margin-left: 50%;
  }

  & &__link {
    display: inline-block;
  }

  & &__dropdown {
    padding: 8px 0 0;

    .ui-dropdown-scrollview {
      overflow-y: hidden;
    }
  }

  & &__empty {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 48px;
  }
}
</style>
